import HomeScreenContainer from "../../collections/HomeScreen/HomeScreenContainer"
import { WazToolbar } from "../toolbar/WazToolbar"
import "./WazHome.css"

type WazHomeProps = {

}

export const WazHome = ({} : WazHomeProps) => {

    return (
        
        <div className="wazawan-home">
            <WazToolbar />
            <HomeScreenContainer />
        </div>
            
    )
}